import { toast } from 'react-toastify';
import { ChatMessage } from '../../types';

export const blockedAnimalWords: string[] = [
  /*
  'dog',
  'horse',
  'wolf',
  'pig',
  'cat',
  'cow',
  'sheep',
  'goat',
  'donkey',
  'monkey',
  */
  'zoophilia',
  'animal sex',
  'beastiality',
  'animal abuse',
  'animal cruelty',
  'animal abuse',
  'animal cruelty',
  'animal abuse',
  'animal cruelty',
  'zoophile',
  'zoo porn',
  'animal porn',
  'animal mating',
  'animal breeding',
  'animal penetration',
  'animal intercourse',
  'animal sex',
];
export const blockedUnderageWords: string[] = [
  '8yo', '8 yo', '8 years old', '8-year-old', '8 y.o.', '8yrs', '8 yrs', '8y', '8 y',
  '9yo', '9 yo', '9 years old', '9-year-old', '9 y.o.', '9yrs', '9 yrs', '9y', '9 y',
  '10yo', '10 yo', '10 years old', '10-year-old', '10 y.o.', '10yrs', '10 yrs', '10y', '10 y',
  '11yo', '11 yo', '11 years old', '11-year-old', '11 y.o.', '11yrs', '11 yrs', '11y', '11 y',
  '12yo', '12 yo', '12 years old', '12-year-old', '12 y.o.', '12yrs', '12 yrs', '12y', '12 y',
  '13yo', '13 yo', '13 years old', '13-year-old', '13 y.o.', '13yrs', '13 yrs', '13y', '13 y',
  '14yo', '14 yo', '14 years old', '14-year-old', '14 y.o.', '14yrs', '14 yrs', '14y', '14 y',
  '15yo', '15 yo', '15 years old', '15-year-old', '15 y.o.', '15yrs', '15 yrs', '15y', '15 y',
  '16yo', '16 yo', '16 years old', '16-year-old', '16 y.o.', '16yrs', '16 yrs', '16y', '16 y',
  '17yo', '17 yo', '17 years old', '17-year-old', '17 y.o.', '17yrs', '17 yrs', '17y', '17 y',
  'underage',
  'under 18',
  'preteen',
  'preteenager',
  'prepubescent',
  'teen',
  'child',
  'kid',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'minor',
  'youngster',
  'adolescent',
  'juvenile',
  'schoolgirl',
  'schoolboy',
  'young teen',
  'young child',
  'little girl',
  'little boy',
  'lolita',
  'pedophile',
  'pedophilia',
  'infant',
  'toddler',
  'prepubescent',
  'childlike',
  'childish',
  'childhood',
  'kindergarten',
  'preschool',
  'elementary school',
  'middle school',
  'high school',
];
export const blockedOtherWords: string[] = [
  'rape',
  'raping',
  'non-consensual',
  'nonconsensual',
  'extreme violence',
  'mutilation',
  'dismemberment',
  'scat',
  'defecation',
  'vomiting',
  'menstruation',
  'forced sex',
  'sexual assault',
  'sexual violence',
  'sexual abuse',
  'menstrual',
  'vomit',
  'blood',
  'gore',
  'extreme violence',
];

/**
 * Hook for chat content moderation
 * Returns a function to check if latest message contains prohibited content
 */
const useChatModeration = () => {
  // Lists of prohibited words by category
  //const blockedOtherWords: string[] = [''];

  /**
   * Checks the latest message in the array for prohibited content
   * @param messages Array of chat messages to check
   * @returns Object containing flag indicating if content violates rules
   */
  const validateLatestMessageContent = (
    messages: ChatMessage[],
  ): { hasProhibitedContent: boolean } => {
    // Return early if no messages
    if (!messages || messages.length === 0) {
      return { hasProhibitedContent: false };
    }

    // Get only the last message for checking
    const latestMessage = messages[messages.length - 1];

    // Skip checking if no content
    if (!latestMessage.content) {
      return { hasProhibitedContent: false };
    }

    const lowerCaseContent = latestMessage.content.toLowerCase();

    // Check for animal-related prohibited words
    for (const word of blockedAnimalWords) {
      if (lowerCaseContent.includes(word)) {
        toast.error(
          'Your message contains prohibited bestiality-related content. Please edit the message. If this is an error, please contact us at hello@TheUncensored.AI',
          { autoClose: 7000 },
        );
        return { hasProhibitedContent: true };
      }
    }

    // Check for other prohibited words
    for (const word of blockedUnderageWords) {
      if (lowerCaseContent.includes(word)) {
        toast.error(
          'Your message contains prohibited underage content. Please edit the message. If this is an error, please contact us at hello@TheUncensored.AI',
          { autoClose: 7000 },
        );
        return { hasProhibitedContent: true };
      }
    }

    // Check for other prohibited words
    for (const word of blockedOtherWords) {
      if (lowerCaseContent.includes(word)) {
        toast.error(
          'Your message contains prohibited content. Please edit the message. If this is an error, please contact us at hello@TheUncensored.AI',
          { autoClose: 7000 },
        );
        return { hasProhibitedContent: true };
      }
    }

    // No prohibited content found
    return { hasProhibitedContent: false };
  };

  return validateLatestMessageContent;
};

export default useChatModeration;
